
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface IndustryFilterProps {
  industryFilter: string;
  onIndustryChange: (value: string) => void;
  industries: string[];
}

export function IndustryFilter({
  industryFilter,
  onIndustryChange,
  industries = [],
}: IndustryFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Industry</Label>
      <Select value={industryFilter} onValueChange={onIndustryChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded-sm">
          <SelectValue placeholder="Select industry" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded-sm">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All industries</SelectItem>
          {industries.map((industry) => (
            <SelectItem key={industry} value={industry} className="text-foreground hover:bg-accent">
              {industry}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
